import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationBidderService {
  apiUrl: string = environment.PROCUREMENT_API_SERVER;
  constructor(private _httpClient: HttpClient) {}
  bidderId: any;
  bidder: any;
  OrganizationBidder: any;
  tenderAmount;
  tenderDetails;

  getAllOrganizationBidder(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/organization-bidder/get-all-organization-bidders/`,
      {
        params: payload.params,
      }
    );
  }
  getAllBidderDocument(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-doc/get-all-procurement-tender-docs/`,
      {
        params: payload.params,
      }
    );
  }
  getOrganizationBidderOverview(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/bidder/${payload.bidderId}/projects-overview`
    );
  }
  getpaymentStatus(payload): Observable<any> {
    return this._httpClient.get(
      `${this.apiUrl}/procurement-tender-payment/${payload.lotId}/${payload.biddingStageId}/${payload.bidderId}/status`
    );
  }
}
